import React from 'react';
export function RentualIcon({
  size = 32
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-254">
      <rect width="64" height="64" rx="14" fill="#2563EB" data-id="element-255" />
      <path d="M32 16L14 30H20V46H28V38H36V46H44V30H50L32 16Z" fill="white" data-id="element-256" />
    </svg>;
}